import { createRouter, createWebHistory } from "vue-router";
import Login from "@/pages/Login.vue";
import LoginCallback from "@/pages/LoginCallback.vue";
import LoginSample from "@/pages/LoginSample.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/ResellerAccountScan", name: "auth.reselleraccountscan", component: () => import("@/pages/ResellerAccountScan.vue") },
    {
      path: "/",
      name: "统一登录",
      component: Login,
    },
    {
      path: "/LoginCallback",
      name: "登录回调",
      component: LoginCallback,
    },
    {
      path: "/LoginSample",
      name: "体验店登录",
      component: LoginSample,
    },
  ],
});

export default router;
